'use client'

import { useEffect } from 'react'

import { useExperimentsContext } from '../components/ExperimentsContext'
import { useGetExperiment } from '../hooks'
import { EXPERIMENT_NAME_LOGIN_TWO_STEP } from '../model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../model/EXPERIMENT_VARIATION'

export const useShouldUseTwoStepLogin = (): boolean => {
  const { addExperimentKeysForActivation } = useExperimentsContext()
  const { isEnabled, variant } = useGetExperiment(
    EXPERIMENT_NAME_LOGIN_TWO_STEP,
  )

  useEffect(() => {
    if (isEnabled) {
      addExperimentKeysForActivation(EXPERIMENT_NAME_LOGIN_TWO_STEP)
    }
  }, [addExperimentKeysForActivation, isEnabled])

  return isEnabled && variant === EXPERIMENT_VARIATION.V1
}
